var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightningGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50793 18.4257C6.26174 18.2622 6.23425 18.1666 6.32938 17.8795C7.06324 15.7016 7.7971 13.519 8.53552 11.341C8.55817 11.2772 8.57627 11.2089 8.60345 11.1269C8.52148 11.127 8.46684 11.1271 8.40764 11.1272C7.41037 11.129 6.4131 11.1308 5.41584 11.1325C5.06065 11.1331 4.92822 10.9239 5.08248 10.6003C6.43446 7.74729 7.78645 4.89427 9.13388 2.04125C9.22461 1.84528 9.36563 1.76306 9.57965 1.76268C10.9685 1.76479 12.3574 1.75779 13.7463 1.75989C14.1379 1.7592 14.2841 2.01395 14.0844 2.35584C13.081 4.07892 12.0777 5.802 11.0789 7.52508C11.0471 7.57978 11.0153 7.63448 10.9699 7.71652C11.0474 7.72094 11.1066 7.72539 11.1612 7.7253C12.122 7.7236 13.0829 7.72191 14.0392 7.72022C14.0938 7.72012 14.1484 7.71548 14.2031 7.72449C14.531 7.76945 14.6591 8.06977 14.4637 8.33423C14.073 8.85404 13.6823 9.37386 13.2871 9.89368C11.1972 12.6569 9.11194 15.4247 7.02208 18.1834C6.94484 18.2837 6.82201 18.3523 6.71742 18.4344C6.63544 18.4255 6.57169 18.4256 6.50793 18.4257Z",
    fill: "#59A310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightningGreen);
export default __webpack_public_path__ + "static/media/lightning-green.f1890bacb2fa6ecb2e0a513d8bbabf2c.svg";
export { ForwardRef as ReactComponent };